import { httpRequest } from "../../http";

export type ReprocessMode = "full_rebuild" | "conversions_only";

export class CommandReprocessAllFiles {
  /** Re-run every stored file for this definition's population, in file-date
   *  order (MPN-1490) — loaded or validated-but-never-loaded alike (MPN-1764);
   *  a stored file that cannot run makes the server refuse with the file names.
   *  The server picks the rebuild flavour from publish state — a full reset is
   *  impossible once an audience is live on a network — and returns which one
   *  it used, plus how far it replayed. */
  async run(
    definitionId: number,
    override?: { reason: string },
  ): Promise<{ job_id: number; replay_through: string | null; mode: ReprocessMode }> {
    const params = new URLSearchParams();
    // Billed-period override (MPN-1516). On a live PFR population a rebuild
    // rewrites closed invoiced months by definition, so the server refuses
    // without both of these; it snapshots those months first.
    if (override) {
      params.set("override_billed_period", "true");
      params.set("override_reason", override.reason);
    }
    const qs = params.size ? `?${params}` : "";
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/reprocess-all/${qs}`;
    return httpRequest<{ job_id: number; replay_through: string | null; mode: ReprocessMode }>(url, {
      method: "POST",
    });
  }
}
